export enum AlertType {
  Information = 'Information',
  Warning = 'Warning',
  Error = 'Error',
  Success = 'Success'
}



// WEBPACK FOOTER //
// ./src/app/pillar/alerts/models/AlertType.ts